import type { CSSObject } from '@emotion/react'

import type {
  Breakpoints,
  BreakpointSize
} from '../../../themes/theme-keys/breakpoints'

export const classes = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden',
    WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
    display: 'flex'
  } as CSSObject,
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column',
    height: '100%'
  } as CSSObject,
  /* Styles applied to the flex container element if `centered={true}` & `!mode="scrollable"`. */
  centered: {
    justifyContent: 'center'
  } as CSSObject,
  /* Styles applied to the tablist element. */
  scroller: {
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap'
  } as CSSObject,
  /* Styles applied to the tablist element if `!mode="scrollable"`. */
  fixed: {
    overflow: 'hidden',
    width: '100%'
  } as CSSObject,
  /* Styles applied to the tablist element if `mode="scrollable"`. */
  scrollable: {
    // Hide dimensionless scrollbar on MacOS
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none' // Safari + Chrome
    }
  } as CSSObject,
  scrollableHorizontal: {
    overflowY: 'hidden',
    overflowX: 'scroll'
  } as CSSObject,
  scrollableVertical: {
    overflowY: 'scroll',
    overflowX: 'hidden'
  } as CSSObject,
  /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
  scrollButtonsDesktop: (
    breakpoints: Breakpoints,
    size?: number | BreakpointSize
  ) =>
    size
      ? ({
          [breakpoints.down(size)]: {
            display: 'none'
          }
        } as CSSObject)
      : {},
  /* Styles applied to the `TabIndicator` component. */
  indicator: {} as CSSObject
}
